import React from 'react';

const Footer = () => {
  return (
    <footer className="relative border-t border-phantom/10 pt-14 pb-8 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="/GhostText.png"
                alt="Ghost Text logo"
                className="h-8 w-auto rounded-lg"
              />
              <span className="font-display text-lg font-bold text-bone">Ghost Text</span>
            </div>
            <p className="text-mist text-sm leading-relaxed">
              Copy the uncopyable. Text recognition for macOS that never
              phones home.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-mono text-xs tracking-[0.2em] uppercase text-phantom/80">Product</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="#how-it-works" className="text-mist hover:text-bone transition-colors">
                  How it works
                </a>
              </li>
              <li>
                <a href="#features" className="text-mist hover:text-bone transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-mist hover:text-bone transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#faq" className="text-mist hover:text-bone transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Support */}
          <div className="space-y-4">
            <h3 className="font-mono text-xs tracking-[0.2em] uppercase text-phantom/80">Legal & support</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="/terms" className="text-mist hover:text-bone transition-colors">
                  Terms of service
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-mist hover:text-bone transition-colors">
                  Privacy policy
                </a>
              </li>
              <li>
                <a href="mailto:support@ghosttext.app" className="text-mist hover:text-bone transition-colors">
                  support@ghosttext.app
                </a>
              </li>
            </ul>
          </div>

          {/* Support Us */}
          <div className="space-y-4">
            <h3 className="font-mono text-xs tracking-[0.2em] uppercase text-phantom/80">Support us</h3>
            <p className="text-mist text-sm">
              Ghost Text is built by one person. A coffee keeps the updates coming.
            </p>
            <button
              onClick={() => window.open('https://buymeacoffee.com/anandsahni', '_blank')}
              className="btn-secondary w-full !py-2.5 text-sm"
            >
              ☕ Buy me a coffee
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-phantom/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-mist text-sm">
            © 2025 Ghost Text. All rights reserved.
          </p>
          <div className="flex items-center gap-3 font-mono text-xs text-mist">
            <span>Made for macOS</span>
            <span className="w-1 h-1 bg-mist/50 rounded-full"></span>
            <span>100% offline</span>
          </div>
        </div>
      </div>

      {/* Ghosted wordmark — barely there, like the text this app captures */}
      <div
        aria-hidden="true"
        className="font-display font-bold text-center select-none pointer-events-none text-[16vw] leading-none text-phantom/[0.045] -mb-[6vw] mt-10"
      >
        GHOST TEXT
      </div>
    </footer>
  );
};

export default Footer;
